import React from 'react';

class LoadMoreOption extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: 'Load More',
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ msg: 'Load More' });
  }
  handleOnClick(event) {
    event.preventDefault();
    this.setState({ msg: 'Loading' });
    this.props.onClick();
  }
  render() {
    if (this.props.show === true) {
      return (<div className="rq-loadmore-button"><button type="button" onClick={this.handleOnClick.bind(this)}>
        {this.state.msg}
      </button></div>);
    }
    return (<div></div>);
  }
}

LoadMoreOption.propTypes = {
  'onClick': React.PropTypes.func,
  'show': React.PropTypes.bool,
};

export default LoadMoreOption;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/bar/loadMoreOption.js
 **/